import * as React from "react";
import type { SVGProps } from "react";
const SvgUserProfileAdd = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#000"
      d="M1.4 21.6a1 1 0 0 0 2 0h-2m1-3.6h1zm10.2-2.6a1 1 0 1 0 0-2v2m9 1.2a1 1 0 1 0 0-2v2m-5.4-2a1 1 0 1 0 0 2v-2m1.7 3.7a1 1 0 0 0 2 0h-2m2-5.4a1 1 0 1 0-2 0h2M14.4 6h-1a2.6 2.6 0 0 1-2.6 2.6v2A4.6 4.6 0 0 0 15.4 6zm-3.6 3.6v-1A2.6 2.6 0 0 1 8.2 6h-2a4.6 4.6 0 0 0 4.6 4.6zM7.2 6h1a2.6 2.6 0 0 1 2.6-2.6v-2A4.6 4.6 0 0 0 6.2 6zm3.6-3.6v1A2.6 2.6 0 0 1 13.4 6h2a4.6 4.6 0 0 0-4.6-4.6zM2.4 21.6h1V18h-2v3.6zM6 14.4v-1A4.6 4.6 0 0 0 1.4 18h2A2.6 2.6 0 0 1 6 15.4zm0 0v1h6.6v-2H6zm15.6 1.2v-1h-2.7v2h2.7zm-2.7 0v-1h-2.7v2h2.7zm0 2.7h1v-2.7h-2v2.7zm0-2.7h1v-2.7h-2v2.7z"
    />
  </svg>
);
export default SvgUserProfileAdd;
